module.exports = __webpack_public_path__ + "img/team_joana.27a7405e.png";